import React from 'react';
import { Link } from 'gatsby';
import css from './index.module.scss';
import { Image } from '../Image';
import { InfoHeader, InfoHeaderProps } from '../InfoHeader';

interface ArticleLinkProps extends InfoHeaderProps {
  slug: string;
  date: string;
  imgUrl?: string;
  imgFit?: string;
  imgColor?: string;
}

export const ArticleLink = (props: ArticleLinkProps) => (
  <li key={props.slug} className={css.container}>
    <Link className={css.link} to={`/blog${props.slug}`}>
      <Image
        src={props.imgUrl}
        className={css.img}
        style={{
          objectFit: props.imgFit as any,
          backgroundColor: props.imgColor,
        }}
      />
      <InfoHeader
        title={props.title}
        subtitle={props.subtitle}
        description={props.description}
      />
    </Link>
  </li>
);
